import { setContractorActiveFilter } from 'store/contractor-active-filter/actions'
import { VisibilityFilters } from 'actions'
import { connect } from 'react-redux'
import ManageContractors from './ManageContractors'

// Extra check to see if the employer id has changed. Need this to cater for loading this page directly from a url
const mapStateToProps = (state, ownProps) => ({
  showActiveOnly: state.contractorActiveFilter.filter === VisibilityFilters.SHOW_ACTIVE ||
  (
    state.contractorActiveFilter.filter !== VisibilityFilters.SHOW_ACTIVE
    &&
    state.contractorActiveFilter.employerId !== ownProps.employerId
  )
})

const mapDispatchToProps = dispatch => ({
  setContractorActiveFilter: (filter) => {
    dispatch(setContractorActiveFilter(filter))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(ManageContractors)



// WEBPACK FOOTER //
// ./src/components/ManageContractors/index.js